module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "py-3"
  }, [_c('ol', {
    staticClass: "breadcrumb"
  }, [_c('li', {
    staticClass: "breadcrumb-item"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'messages'
      }
    }
  }, [_vm._v("\n                mail\n            ")])], 1), _vm._v(" "), _c('li', {
    staticClass: "breadcrumb-item active"
  }, [_vm._v("\n            " + _vm._s(_vm.item.name) + "\n        ")])]), _vm._v(" "), _c('h1', [_vm._v(_vm._s(_vm.item.name))]), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.item.content)
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a5bab86c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/messages/views/Details.vue
// module id = 110
// module chunks = 1